import type { ChallengeCondition } from "@/sales-tools/challenges/api/getChallengesForEmployee";

export const isDisqualified = (conditions: ChallengeCondition[]) =>
    conditions.some((c) => c.threshold === "UPPER_LIMIT" && c.currentValue > c.targetValue);
